import React, { useEffect, useMemo, useState } from "react";
import {
  fetchResourceTilesByIds,
  type ResourceTileProps,
} from "../../utils/contentful-helpers";
import BookmarkMentorsCard from "../../components/Cards/BookmarkMentorsCard";
import { useAppSelector } from "../../app/store";
import { fetchHomePageData } from "../../components/fetchHomePageData";
import type { Mentor } from "../../shared/mentorTypes";
import styles from "./Bookmarks.module.css";
import ResourceTilesGrid from "../../components/ResourcePage/ResourceTileGrid";

const Bookmarks = () => {
  const mentorBookmarks = useAppSelector(
    (state) => state.mentorBookmarks.bookmarks,
  );
  const resourceBookmarks = useAppSelector(
    (state) => state.resourceBookmarks.bookmarks,
  );

  const bookmarkedMentorIds = useMemo(
    () => mentorBookmarks.map((bookmark) => bookmark.mentorId),
    [mentorBookmarks],
  );

  const bookmarkedResourceIds = useMemo(
    () => resourceBookmarks.map((bookmark) => bookmark.resourceId),
    [resourceBookmarks],
  );

  const [bookmarkedResources, setBookmarkedResources] = useState<
    ResourceTileProps[]
  >([]);
  const [bookmarkedMentors, setBookmarkedMentors] = useState<Mentor[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resources = await fetchResourceTilesByIds(bookmarkedResourceIds);
        setBookmarkedResources(resources);
      } catch (error) {
        console.error("Failed to fetch bookmarked resources:", error);
      }
    };

    void fetchData();
  }, [bookmarkedResourceIds]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const homePageData = await fetchHomePageData();
        setBookmarkedMentors(
          homePageData.mentors.filter((mentor) =>
            bookmarkedMentorIds.some((id) => id === mentor._id),
          ),
        );
      } catch (error) {
        console.error("Failed to fetch home page data:", error);
      }
    };

    void fetchData();
  }, [bookmarkedMentorIds]);

  return (
    <>
      <div className={styles.bookmarks}>
        <h2 className={styles.favoriteResources}>Favorite Resources</h2>
        {bookmarkedResources.length === 0 ? (
          <p>No favorite resources yet.</p>
        ) : (
          <ResourceTilesGrid
            resourceTiles={bookmarkedResources}
            bookmarkSource="BookmarksPage"
          />
        )}
      </div>

      <div className={styles.bookmarks}>
        <h2 className={styles.favoriteMentors}>Favorite Mentors</h2>
        <div className={styles.mentorBookmarkTiles}>
          {bookmarkedMentors.length === 0 ? (
            <p>No favorite mentors yet.</p>
          ) : (
            bookmarkedMentors.map((mentor) => (
              <BookmarkMentorsCard
                key={mentor._id}
                mentor={mentor}
              />
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default Bookmarks;
